import GrComponentFactory from "../gr_component_factory";
import { PropTypes } from "react";
import { connect } from "reflux";
import { focusOnMount } from "../../modules/react_ref_helpers";
import LongTextPopupForm from "../forms/long_text_popup_form";
import GeneralStatusUpdateActions from "../../react_actions/general_status_update_actions";
import GeneralStatusUpdateStore from "../../react_stores/general_status_update_store";

const promptText = "Share your book thoughts with friends...";
const textareaHtmlId = "generalStatusUpdateFormTextarea";

export default GrComponentFactory.createClass({
  displayName: "GeneralStatusUpdateButton",

  mixins: [connect(GeneralStatusUpdateStore, "generalStatusUpdate")],

  propTypes: {
    characterLimit: PropTypes.number.isRequired,
  },

  getInitialState() {
    return {
      updateText: "",
    };
  },

  isFormOpen() {
    return this.state.generalStatusUpdate.creationInProgress;
  },

  syncUpdateText(text) {
    this.setState({ updateText: text });
  },

  renderForm() {
    if (this.isFormOpen()) {
      return (
        <LongTextPopupForm
          characterLimit={this.props.characterLimit}
          text={this.state.updateText}
          onCancel={GeneralStatusUpdateActions.closeCreationDialog}
          onSubmit={GeneralStatusUpdateActions.save}
          onTextChange={this.syncUpdateText}
          header={<label htmlFor={textareaHtmlId}>{promptText}</label>}
          saveInProgress={this.state.generalStatusUpdate.saveInProgress}
          textareaProps={
            {
              id: textareaHtmlId,
              ref: focusOnMount,
              required: true,
            }
          }
        />
      );
    }
  },

  render() {
    return (
      <span aria-live="polite">
        <button className="gr-buttonAsLink"
                onClick={GeneralStatusUpdateActions.openCreationDialog}
                disabled={this.isFormOpen()}>
          General update
        </button>
        {this.renderForm()}
      </span>
    );
  },
});
